export const TASK_STATUS = {
  QUEUED: 'queued',
  IN_PROGRESS: 'inProgress',
  COMPLETED: 'Success',
  FAILED: 'failed',
};
